/*
  DORVETTI — Ficha de producto (MOV-030). Acompaña a sections/dorvetti-product.liquid.
  - Opciones: miniaturas de metal, rejilla de tallas y otras opciones; con cada cambio se busca la
    variante, se actualizan precio, etiqueta de descuento, disponibilidad y ?variant= de la URL.
    La talla no viene elegida: «Add to bag» sin talla avisa y marca la rejilla, como Gymshark.
  - Añadir: /cart/add.js y se abre el carrito lateral (evento dv:cart:added de dorvetti-cart.js).
  - Galería: índice vertical con flechas (progreso del scroll) y zoom a pantalla completa.
  - Paneles laterales [data-dv-side]: guía de tallas, complete the look y envío.
  - Compartir: hoja nativa del sistema o, si no hay, copia el enlace.
*/
(() => {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const pdp = document.querySelector('[data-dv-pdp]');
  if (!pdp) return;

  let product = null;
  try {
    product = JSON.parse(pdp.querySelector('[data-dv-product-json]').textContent);
  } catch (error) {
    return;
  }

  const sizeIndex = Number(pdp.dataset.sizeIndex);
  const swatchIndex = Number(pdp.dataset.swatchIndex);
  const moneyFormat = pdp.dataset.moneyFormat || '€{{amount}}';
  const labels = {
    add: pdp.dataset.labelAdd,
    soldOut: pdp.dataset.labelSoldOut,
    chooseSize: pdp.dataset.labelChooseSize,
    ringSize: pdp.dataset.labelRingSize || pdp.dataset.labelChooseSize,
    error: pdp.dataset.labelError,
    copied: pdp.dataset.labelCopied
  };

  // Formato de dinero de Shopify ({{amount}}, {{amount_with_comma_separator}}…).
  const formatMoney = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const fixed = (n, d) => n.toFixed(d);
    const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const patterns = {
      amount: () => { const [a, b] = fixed(value, 2).split('.'); return `${group(a, ',')}.${b}`; },
      amount_no_decimals: () => group(fixed(value, 0), ','),
      amount_with_comma_separator: () => { const [a, b] = fixed(value, 2).split('.'); return `${group(a, '.')},${b}`; },
      amount_no_decimals_with_comma_separator: () => group(fixed(value, 0), '.'),
      amount_with_apostrophe_separator: () => { const [a, b] = fixed(value, 2).split('.'); return `${group(a, "'")}.${b}`; }
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => (patterns[key] || patterns.amount)());
  };

  // ── Opciones y variantes ────────────────────────────────────────────
  const optionCount = (product.options || []).length;
  const selected = new Array(optionCount).fill(null);
  const current = product.variants.find((v) => String(v.id) === String(pdp.querySelector('[data-dv-variant-id]').value)) || product.variants[0];
  (current.options || []).forEach((value, i) => {
    if (i !== sizeIndex) selected[i] = value;
  });
  if (product.variants.length === 1) selected.splice(0, optionCount, ...(current.options || []));

  const groups = [...pdp.querySelectorAll('[data-dv-option]')];
  const idInput = pdp.querySelector('[data-dv-variant-id]');
  const addButton = pdp.querySelector('[data-dv-add]');
  const addLabel = pdp.querySelector('[data-dv-add-label]');
  const priceEl = pdp.querySelector('[data-dv-price]');
  const compareEl = pdp.querySelector('[data-dv-compare]');
  const badgeEl = pdp.querySelector('[data-dv-badge]');
  const msgEl = pdp.querySelector('[data-dv-pdp-msg]');

  const say = (text) => {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
  };

  const findVariant = () =>
    product.variants.find((v) => (v.options || []).every((value, i) => selected[i] === value)) || null;

  // Disponibilidad de cada valor con el resto de lo elegido.
  const availableWith = (index, value) =>
    product.variants.some((v) => v.available && v.options[index] === value && v.options.every((val, i) => i === index || i === sizeIndex || selected[i] === null || selected[i] === val));

  const render = () => {
    groups.forEach((group) => {
      const index = Number(group.dataset.dvOption);
      group.querySelectorAll('[data-dv-value]').forEach((button) => {
        const value = button.dataset.dvValue;
        const on = selected[index] === value;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-pressed', String(on));
        const available = availableWith(index, value);
        button.classList.toggle('is-unavailable', !available);
        if (index === sizeIndex) button.disabled = !available;
      });
      const label = group.querySelector('[data-dv-option-label]');
      if (label) label.textContent = selected[index] || '';
    });

    const variant = findVariant();
    // Sin talla elegida, el precio es el de la primera variante que encaja con lo elegido (p. ej. el metal).
    const shown = variant || product.variants.find((v) => v.options.every((val, i) => selected[i] === null || selected[i] === val)) || current;
    if (priceEl) priceEl.textContent = shown.price > 0 ? formatMoney(shown.price) : '';
    const save = shown.compare_at_price && shown.compare_at_price > shown.price ? shown.compare_at_price - shown.price : 0;
    if (compareEl) {
      compareEl.hidden = save === 0;
      compareEl.textContent = save ? formatMoney(shown.compare_at_price) : '';
    }
    if (badgeEl) {
      badgeEl.hidden = save === 0;
      if (save) badgeEl.textContent = `${Math.round((save * 100) / shown.compare_at_price)}% off | Save ${formatMoney(save)}`;
    }
    if (variant) {
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? labels.add : labels.soldOut;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', url);
    } else {
      addButton.disabled = false;
      addLabel.textContent = labels.add;
    }
  };

  // La miniatura de metal cambia la primera foto por la de esa variante.
  const firstImage = pdp.querySelector('[data-dv-gallery-item] img');
  const firstSrc = firstImage ? { src: firstImage.getAttribute('src'), srcset: firstImage.getAttribute('srcset') } : null;
  const showVariantImage = () => {
    if (!firstImage || swatchIndex < 0) return;
    const match = product.variants.find((v) => v.options[swatchIndex] === selected[swatchIndex] && v.featured_image);
    if (!match) return;
    const media = match.featured_image.src;
    if (!media) return;
    const base = media.split('?')[0];
    const isFirst = firstSrc && firstSrc.src && firstSrc.src.split('?')[0].includes(base.split('/').pop());
    if (isFirst) {
      firstImage.setAttribute('src', firstSrc.src);
      if (firstSrc.srcset) firstImage.setAttribute('srcset', firstSrc.srcset);
      return;
    }
    firstImage.setAttribute('src', `${base}?width=1200`);
    firstImage.setAttribute('srcset', [540, 720, 900, 1200, 1500].map((w) => `${base}?width=${w} ${w}w`).join(', '));
  };

  pdp.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dv-option] [data-dv-value]');
    if (!button || button.disabled) return;
    const index = Number(button.closest('[data-dv-option]').dataset.dvOption);
    selected[index] = button.dataset.dvValue;
    if (index === swatchIndex) {
      showVariantImage();
      // Si la talla elegida no existe en el nuevo metal, se deselecciona.
      if (sizeIndex >= 0 && selected[sizeIndex] && !availableWith(sizeIndex, selected[sizeIndex])) selected[sizeIndex] = null;
    }
    pdp.querySelector('[data-dv-size-group]')?.classList.remove('is-missing');
    say('');
    render();
  });

  // ── Añadir a la bolsa ───────────────────────────────────────────────
  const addToCart = async (id, button, messageEl, properties) => {
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const item = { id: Number(id), quantity: 1 };
      if (properties) item.properties = properties;
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      const json = await response.json();
      if (!response.ok) throw json;
      document.dispatchEvent(new CustomEvent('dv:cart:added', { detail: json }));
      return true;
    } catch (error) {
      const text = (error && error.description) || labels.error;
      if (messageEl) {
        messageEl.textContent = text;
        messageEl.hidden = false;
      }
      return false;
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  };

  pdp.querySelector('[data-dv-pdp-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (sizeIndex >= 0 && !selected[sizeIndex]) {
      pdp.querySelector('[data-dv-size-group]')?.classList.add('is-missing');
      say(labels.chooseSize);
      pdp.querySelector('[data-dv-size-group] [data-dv-value]:not(:disabled)')?.focus({ preventScroll: false });
      return;
    }
    // Anillos sin tallas del proveedor (NEEDS_RING_SIZE): la talla la escribe el cliente.
    const ringInput = pdp.querySelector('[data-dv-ring-size-input]');
    const ringSize = ringInput ? ringInput.value.trim() : '';
    if (ringInput && !ringSize) {
      ringInput.closest('[data-dv-ring-size]')?.classList.add('is-missing');
      say(labels.ringSize);
      ringInput.focus({ preventScroll: false });
      return;
    }
    const variant = findVariant();
    if (!variant || !variant.available) return;
    say('');
    addToCart(variant.id, addButton, msgEl, ringInput ? { 'Ring size': ringSize } : null);
  });

  pdp.querySelector('[data-dv-ring-size-input]')?.addEventListener('input', (event) => {
    event.target.closest('[data-dv-ring-size]')?.classList.remove('is-missing');
    say('');
  });

  // Complete the look: cada pieza con su selector y su botón.
  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-dv-look-add]');
    if (!add) return;
    const item = add.closest('[data-dv-look-item]');
    const field = item.querySelector('[data-dv-look-variant]');
    const msg = item.querySelector('[data-dv-look-msg]');
    if (!field || !field.value) {
      field?.focus();
      if (msg) {
        msg.textContent = labels.chooseSize;
        msg.hidden = false;
      }
      return;
    }
    if (msg) msg.hidden = true;
    addToCart(field.value, add, msg).then((ok) => {
      if (ok) closeSide();
    });
  });

  // ── Paneles laterales ───────────────────────────────────────────────
  let openSide = null;
  let lastFocus = null;
  const closeSide = () => {
    if (!openSide) return;
    const side = openSide;
    side.classList.remove('is-open');
    document.documentElement.classList.remove('dv-side-open');
    openSide = null;
    window.setTimeout(() => {
      side.hidden = true;
      lastFocus?.focus?.({ preventScroll: true });
    }, 380);
  };
  const openPanel = (id) => {
    const side = document.getElementById(id);
    if (!side) return;
    if (openSide) closeSide();
    lastFocus = document.activeElement;
    side.hidden = false;
    document.documentElement.classList.add('dv-side-open');
    openSide = side;
    window.requestAnimationFrame(() => {
      side.classList.add('is-open');
      side.querySelector('.dv-side__panel')?.focus({ preventScroll: true });
    });
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dv-side-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener.dataset.dvSideOpen);
      return;
    }
    if (event.target.closest('[data-dv-side-close]')) closeSide();
    const unit = event.target.closest('[data-dv-unit]');
    if (unit) {
      const box = unit.closest('[data-dv-units]');
      box.dataset.dvUnits = unit.dataset.dvUnit;
      box.querySelectorAll('[data-dv-unit]').forEach((b) => {
        const on = b === unit;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
    }
  });
  document.addEventListener('keydown', (event) => {
    if (!openSide) return;
    if (event.key === 'Escape') closeSide();
    if (event.key !== 'Tab') return;
    const items = [...openSide.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === openSide.querySelector('.dv-side__panel'))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // «Read more»: baja a la descripción completa.
  pdp.querySelector('[data-dv-more]')?.addEventListener('click', () => {
    document.getElementById('DvPdpDetails')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Compartir.
  pdp.querySelector('[data-dv-share]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    const data = { title: button.dataset.title, url: button.dataset.url };
    try {
      if (navigator.share) {
        await navigator.share(data);
        return;
      }
      await navigator.clipboard.writeText(data.url);
      const label = button.querySelector('span');
      const before = label.textContent;
      label.textContent = labels.copied;
      window.setTimeout(() => { label.textContent = before; }, 2000);
    } catch (error) {
      /* hoja cerrada o sin permiso de portapapeles */
    }
  });

  // ── Galería: índice vertical y zoom ─────────────────────────────────
  const gallery = pdp.querySelector('[data-dv-gallery]');
  const items = [...pdp.querySelectorAll('[data-dv-gallery-item]')];
  const thumb = pdp.querySelector('[data-dv-gallery-thumb]');
  const counter = pdp.querySelector('[data-dv-gallery-current]');
  const list = pdp.querySelector('[data-dv-gallery-list]');
  const scroller = () => {
    const wrapper = document.querySelector('.page-wrapper');
    return wrapper && wrapper.scrollHeight > wrapper.clientHeight + 10 ? wrapper : document.scrollingElement;
  };
  const updateIndex = () => {
    if (!gallery || !thumb) return;
    const rect = gallery.getBoundingClientRect();
    const view = window.innerHeight;
    const total = Math.max(rect.height - view, 1);
    const progress = Math.min(Math.max(-rect.top / total, 0), 1);
    const trackH = thumb.parentElement.clientHeight;
    const thumbH = Math.max(24, Math.min(trackH, trackH * (view / rect.height)));
    thumb.style.height = `${thumbH}px`;
    thumb.style.transform = `translateY(${(trackH - thumbH) * progress}px)`;
  };
  const stepTo = (dir) => {
    const sc = scroller();
    const offsets = items.map((el) => el.getBoundingClientRect().top);
    const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dv-bar-h')) || 60;
    let target;
    if (dir > 0) target = offsets.find((top) => top > bar + 8);
    else target = [...offsets].reverse().find((top) => top < bar - 8);
    if (target === undefined) return;
    sc.scrollBy({ top: target - bar, behavior: 'smooth' });
  };
  pdp.querySelector('[data-dv-gallery-prev]')?.addEventListener('click', () => stepTo(-1));
  pdp.querySelector('[data-dv-gallery-next]')?.addEventListener('click', () => stepTo(1));
  const onScroll = () => window.requestAnimationFrame(() => { updateIndex(); stickInfo(); });
  (document.querySelector('.page-wrapper') || window).addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // Móvil: contador «1 / N» de la galería deslizable.
  list?.addEventListener('scroll', () => {
    if (!counter) return;
    const index = Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
    counter.textContent = String(Math.min(items.length, index + 1));
  }, { passive: true });

  // Columna de información fija: si es más alta que la pantalla, se queda pegada por abajo.
  const info = pdp.querySelector('[data-dv-pdp-sticky]');
  function stickInfo() {
    if (!info) return;
    const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--dv-bar-h')) || 60;
    const top = Math.min(bar + 24, window.innerHeight - info.offsetHeight - 24);
    info.style.setProperty('--dv-pdp-top', `${Math.round(top)}px`);
  }

  // Zoom
  const zoom = pdp.querySelector('[data-dv-zoom-box]');
  const zoomImg = pdp.querySelector('[data-dv-zoom-img]');
  const sources = items.map((el) => el.querySelector('[data-zoom-src]')?.dataset.zoomSrc).filter(Boolean);
  let zoomIndex = 0;
  let zoomFocus = null;
  const showZoom = (i) => {
    zoomIndex = (i + sources.length) % sources.length;
    zoomImg.src = sources[zoomIndex];
  };
  const closeZoom = () => {
    zoom.hidden = true;
    document.documentElement.classList.remove('dv-side-open');
    zoomFocus?.focus?.({ preventScroll: true });
  };
  pdp.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dv-zoom]');
    if (trigger && sources.length && window.matchMedia('(min-width: 990px)').matches) {
      zoomFocus = trigger;
      showZoom(Number(trigger.dataset.dvZoom));
      zoom.hidden = false;
      document.documentElement.classList.add('dv-side-open');
      zoom.querySelector('[data-dv-zoom-close]').focus({ preventScroll: true });
      return;
    }
    if (event.target.closest('[data-dv-zoom-close]') || event.target === zoom) closeZoom();
    if (event.target.closest('[data-dv-zoom-prev]')) showZoom(zoomIndex - 1);
    if (event.target.closest('[data-dv-zoom-next]')) showZoom(zoomIndex + 1);
  });
  document.addEventListener('keydown', (event) => {
    if (!zoom || zoom.hidden) return;
    if (event.key === 'Escape') closeZoom();
    if (event.key === 'ArrowLeft') showZoom(zoomIndex - 1);
    if (event.key === 'ArrowRight') showZoom(zoomIndex + 1);
  });

  render();
  updateIndex();
  stickInfo();
  if (window.DvWishlist) window.DvWishlist.sync();
})();
